module.exports = __webpack_public_path__ + "media/images/gallery/constellations/en_layer_on-6a69c49b53adcb90560a8597cd5945be.jpg";